module.exports = __webpack_public_path__ + "img/tasks_white.445bdf53.svg";